import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useAppState from '../../../common/state/appState';
import { IRecentSearch } from '../../../api/types';
import { ContinueSearchingCard } from './ContinueSearchingCard';

export const ContinueSearching: React.FC = () => {
    const recentSearches = useAppState((state) => state.recentSearches) as IRecentSearch[] | undefined;

    if (!recentSearches || recentSearches.length === 0) {
        return null;
    }

    return (
        <Box display="flex" alignItems="center" gap={{ xs: 2, lg: 1.4, xl: 2 }}>
            <Typography variant="h6">
                Continue
                <br />
                searching
            </Typography>
            <Grid
                container
                spacing={1}
                sx={{
                    height: '4.125rem',
                    overflow: 'hidden',
                }}
            >
                {recentSearches.map((item) => (
                    <ContinueSearchingCard
                        key={item.link}
                        title={item.title}
                        inventoryCount={item.inventoryCount}
                        inventoryCountText={item.inventoryCountText}
                        newMatchCount={item.newMatchCount}
                        link={item.link}
                    />
                ))}
            </Grid>
        </Box>
    );
};
